/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type GoalOverviewLifecycleStatus = (typeof GoalOverviewLifecycleStatus)[keyof typeof GoalOverviewLifecycleStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoalOverviewLifecycleStatus = {
  active: "active",
  archived: "archived",
} as const;
